import React, { Component } from 'react'
import { Image, Accordion, ButtonGroup, Button, Modal } from 'react-bootstrap'
import FeedbackForm from './FeedbackForm'
import FavoriteIcon from '../icons/FavoriteIcon'
import styles from './../style/ProductCard.module.scss'
import ClientOnlyFsLightbox from './../block/ClientOnlyFsLightbox'

class ProductCard extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      show_feedback: false,
      show_preorder_feedback: false, // Добавляем состояние для формы предзаказа
      lightboxController: {
        toggler: false,
        slide: 1
      },
      quantity: this.getInitialQuantity(),
      show_cart: false,
      tempQuantity: this.getInitialQuantity().toString(),
      quantityWarning: '',
      // Добавляем состояние для отслеживания, какие аккордеоны открыты
      openAccordions: this.getDefaultOpenAccordions(props) // По умолчанию открыты все разделы
    }
    
    // Кэш для содержимого аккордеонов с видео
    this.accordionContentCache = {}
  }

  getMaxQuantity(props = this.props) {
    const newcount = Number(props?.ajax_data?.options?.newcount)
    return Number.isFinite(newcount) && newcount > 0 ? newcount : Infinity
  }

  getInitialQuantity(props = this.props) {
    const { user_profile_type } = props
    const step = user_profile_type === 'legal' ? 100 : 1
    const maxQuantity = this.getMaxQuantity(props)
    return maxQuantity !== Infinity ? Math.min(step, maxQuantity) : step
  }

  getDefaultOpenAccordions(props = this.props) {
    const openAccordions = new Set()

    if (props?.ajax_data?.options_table?.length > 0) {
      openAccordions.add('9999')
    }

    if (Array.isArray(props?.ajax_data?.accordion)) {
      props.ajax_data.accordion.forEach((item, index) => {
        openAccordions.add(index.toString())
      })
    }

    return openAccordions
  }

  areSetsEqual(setA, setB) {
    if (setA.size !== setB.size) return false
    for (const value of setA) {
      if (!setB.has(value)) return false
    }
    return true
  }

  componentDidMount() {
    this.setState({
      tempQuantity: this.state.quantity.toString()
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.quantity !== this.state.quantity) {
      this.setState({
        tempQuantity: this.state.quantity.toString()
      })
    }

    if (prevProps.ajax_data !== this.props.ajax_data) {
      const defaultOpenAccordions = this.getDefaultOpenAccordions()
      const maxQuantity = this.getMaxQuantity()
      const newState = {}

      if (this.state.quantity > maxQuantity) {
        newState.quantity = maxQuantity
        newState.tempQuantity = maxQuantity.toString()
      }

      if (!this.areSetsEqual(defaultOpenAccordions, this.state.openAccordions)) {
        newState.openAccordions = defaultOpenAccordions
      }

      if (Object.keys(newState).length > 0) {
        this.setState(newState)
      }
    }
  }

  get step() {
    const { user_profile_type } = this.props
    return user_profile_type === 'legal' ? 100 : 1
  }

  get isFavorite() {
    const { favorite, ajax_data } = this.props
    return favorite.includes(ajax_data.id)
  }

  get isInStock() {
    const { ajax_data } = this.props
    return ajax_data.options?.stock > 0
  }

  handleAccordionToggle = (eventKey) => {
    this.setState(prevState => {
      const newOpenAccordions = new Set(prevState.openAccordions)
      if (newOpenAccordions.has(eventKey)) {
        newOpenAccordions.delete(eventKey)
      } else {
        newOpenAccordions.add(eventKey)
      }
      return { openAccordions: newOpenAccordions }
    })
  }

  handleQuantityChange = (e) => {
    const value = e.target.value
    const maxQuantity = this.getMaxQuantity()
    this.setState({ tempQuantity: value })
    
    const numericValue = value.replace(/\D/g, '')
    if (numericValue !== '') {
      const num = Number(numericValue)
      const validatedQuantity = Math.min(num >= this.step ? num : this.step, maxQuantity)
      this.setState({ quantity: validatedQuantity })
    } else {
      const initialQuantity = Math.min(this.step, maxQuantity)
      this.setState({ quantity: initialQuantity })
    }
  }

  handleQuantityBlur = (e) => {
    const numericValue = e.target.value.replace(/\D/g, '')
    const maxQuantity = this.getMaxQuantity()
    const initialQuantity = Math.min(this.step, maxQuantity)

    if (numericValue === '' || Number(numericValue) < this.step) {
      this.setState({
        quantity: initialQuantity,
        tempQuantity: initialQuantity.toString(),
        quantityWarning: ''
      })
    } else {
      const num = Number(numericValue)
      const validatedQuantity = Math.min(num, maxQuantity)
      const quantityWarning = num > maxQuantity
        ? 'Вы пытаетесь положить в корзину больше чем есть в наличии, мы уже поставили актуальное наличие'
        : ''
      this.setState({
        quantity: validatedQuantity,
        tempQuantity: validatedQuantity.toString(),
        quantityWarning
      })
    }
  }

  openLightbox = (slideNumber) => {
    this.setState(prevState => ({
      lightboxController: {
        toggler: !prevState.lightboxController.toggler,
        slide: slideNumber
      }
    }))
  }

  add = () => {
    const { addTocart, ajax_data } = this.props
    const { quantity } = this.state
    
    addTocart({ product: ajax_data.id, count: quantity }, () => {
      this.setState({ show_cart: true })
    })
  }

  incrementQuantity = () => {
    const maxQuantity = this.getMaxQuantity()
    this.setState(prevState => ({
      quantity: Math.min(prevState.quantity + this.step, maxQuantity)
    }))
  }

  decrementQuantity = () => {
    this.setState(prevState => ({
      quantity: prevState.quantity > this.step ? prevState.quantity - this.step : Math.min(this.step, this.getMaxQuantity())
    }))
  }

  setFeedback = (value) => {
    this.setState({ show_feedback: value })
  }

  setPreorderFeedback = (value) => {
    this.setState({ show_preorder_feedback: value })
  }

  priceFormat = (price, delimiter, fraction) => {
    if (price == 0 || price == '') return 0
    fraction = [0, 1, 2].indexOf(fraction) !== -1 ? fraction : 2
    delimiter = delimiter || ' '
    price = (price = parseFloat(price)) && isFinite(price) && price.toFixed(fraction) || false
    if (price === false) throw new TypeError('Price should be a valid integer.')
    const reverseString = function(string) {
      return string.split('').reverse().join('')
    }
    return reverseString(reverseString(price).replace(/(\d{3})/g, '$&' + delimiter))
  }

  copyArticleToClipboard = () => {
    const { ajax_data } = this.props
    const article = ajax_data?.article || ''
    
    navigator.clipboard.writeText(article)
      .then(() => {
        console.log('Артикул скопирован в буфер обмена')
      })
      .catch(err => {
        console.error('Не удалось скопировать артикул: ', err)
      })
  }

  // Метод для безопасной вставки HTML с видео
  renderAccordionContent = (htmlContent, index) => {
    // Используем кэш для предотвращения пересоздания контента
    if (!this.accordionContentCache[index]) {
      this.accordionContentCache[index] = {
        __html: htmlContent
      }
    }
    
    return (
      <div 
        className={styles.accordionBody}
        dangerouslySetInnerHTML={this.accordionContentCache[index]}
      />
    )
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Оптимизация: предотвращаем лишние перерисовки
    const propsChanged = 
      nextProps.ajax_data.id !== this.props.ajax_data.id ||
      nextProps.favorite !== this.props.favorite ||
      nextProps.user_profile_type !== this.props.user_profile_type
    
    const stateChanged = 
      nextState.show_feedback !== this.state.show_feedback ||
      nextState.show_preorder_feedback !== this.state.show_preorder_feedback ||
      nextState.lightboxController.toggler !== this.state.lightboxController.toggler ||
      nextState.quantity !== this.state.quantity ||
      nextState.show_cart !== this.state.show_cart ||
      nextState.tempQuantity !== this.state.tempQuantity ||
      nextState.quantityWarning !== this.state.quantityWarning ||
      nextState.openAccordions !== this.state.openAccordions
    
    return propsChanged || stateChanged
  }

  render() {
    const { 
      options, 
      ajax_data, 
      user_profile_type, 
      changeFavorite 
    } = this.props
    
    const { 
      show_feedback, 
      show_preorder_feedback,
      lightboxController, 
      quantity, 
      show_cart, 
      tempQuantity,
      openAccordions
    } = this.state

    return (
      <div className={styles.productContainer}>
        <ClientOnlyFsLightbox
          toggler={lightboxController.toggler}
          sources={ajax_data.images.map(img => img.image)}
          slide={lightboxController.slide}
        />

        <div 
          className={styles.articleContainer}
          onClick={this.copyArticleToClipboard}
          style={{ cursor: 'pointer' }}
        >
          <span>Арт {ajax_data?.article || ''}</span>
          <svg className={styles.articleIcon} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org2000/svg">
            <path d="M7.62 1H5.673C4.791 1 4.092 1 3.5455 1.074C2.9825 1.15 2.527 1.31 2.168 1.6705C1.8085 2.031 1.649 2.4885 1.5735 3.0535C1.5 3.6025 1.5 4.304 1.5 5.1895V8.1085C1.5 8.8625 1.96 9.5085 2.6135 9.7795C2.58 9.3245 2.58 8.687 2.58 8.156V5.651C2.58 5.0105 2.58 4.458 2.639 4.016C2.7025 3.542 2.8455 3.088 3.2125 2.7195C3.5795 2.351 4.032 2.2075 4.504 2.1435C4.944 2.0845 5.494 2.0845 6.1325 2.0845H7.6675C8.3055 2.0845 8.8545 2.0845 9.295 2.1435C9.16305 1.80665 8.93266 1.51737 8.63388 1.31339C8.33509 1.10941 7.98177 1.0002 7.62 1Z" fill="#3D3D3D" fillOpacity="0.8"/>
            <path d="M3.2998 5.69814C3.2998 4.33514 3.2998 3.65364 3.7218 3.23014C4.1433 2.80664 4.8218 2.80664 6.1798 2.80664H7.6198C8.9773 2.80664 9.6563 2.80664 10.0783 3.23014C10.5003 3.65364 10.4998 4.33514 10.4998 5.69814V8.10814C10.4998 9.47114 10.4998 10.1526 10.0783 10.5761C9.6563 10.9996 8.9773 10.9996 7.6198 10.9996H6.1798C4.8223 10.9996 4.1433 10.9996 3.7218 10.5761C3.2998 10.1526 3.2998 9.47114 3.2998 8.10814V5.69814Z" fill="#3D3D3D" fillOpacity="0.8"/>
          </svg>
        </div>

        <div className="d-flex align-items-center justify-content-between">
          <h1 className={styles.productTitle}>
            {ajax_data?.pagetitle || ''}
          </h1>

          {ajax_data.options.certificate != '' &&
            <div className={styles.certificateBadge + ` d-none d-md-flex`}>
              <span>Код ТРУ: {ajax_data.options.certificate}</span>
              <svg className={styles.badgeIcon} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.5 5.83366V14.167C17.5 16.667 16.25 18.3337 13.3333 18.3337H6.66667C3.75 18.3337 2.5 16.667 2.5 14.167V5.83366C2.5 3.33366 3.75 1.66699 6.66667 1.66699H13.3333C16.25 1.66699 17.5 3.33366 17.5 5.83366Z" stroke="white" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12.9168 1.66699V8.21698C12.9168 8.58365 12.4835 8.76698 12.2168 8.52531L10.2835 6.74201C10.1252 6.59201 9.87514 6.59201 9.71681 6.74201L7.78352 8.52531C7.51685 8.76698 7.0835 8.58365 7.0835 8.21698V1.66699H12.9168Z" stroke="white" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M11.0415 11.667H14.5832" stroke="white" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M7.5 15H14.5833" stroke="white" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          }
        </div>

        <div className={styles.cardsRow}>
          <div className={styles.card}>
            <div className={styles.cardContent}>
              <div className={styles.fourColumnLayout}>
                {ajax_data.images.length > 0 &&
                  <div className={styles.photoColumn}>
                    <div 
                      className={styles.mainPhoto}
                      style={{ cursor: 'pointer' }}
                    >
                      <div onClick={() => changeFavorite(ajax_data.id)} className={styles.favoriteButton + ` d-md-none`}>
                        <FavoriteIcon isFavorite={this.isFavorite} />
                      </div>
                      <img 
                        onClick={() => this.openLightbox(1)} 
                        src={ajax_data.images[0].image_thumb} 
                        alt="Main product" 
                        loading="lazy"
                      />
                    </div>
                    {ajax_data.images.length > 1 &&
                      <div className={styles.thumbnails}>
                        {ajax_data.images.slice(1, 5).map((img, index) => (
                          <div
                            key={index}
                            onClick={() => this.openLightbox(index + 2)}
                            className={styles.thumbnail}
                            style={{ cursor: 'pointer' }}
                          >
                            <img 
                              src={img.image_small} 
                              alt={`Галерея ${index + 1}`} 
                              loading="lazy"
                            />
                          </div>
                        ))}
                      </div>
                    }
                    <div className={styles.photoColumnText + ` d-md-none`}>*Внешний вид товара может отличаться от фотографии</div>
                  </div>
                }

                <div className={styles.favoriteColumn}>
                  <div onClick={() => changeFavorite(ajax_data.id)} className={styles.favoriteButton}>
                    <FavoriteIcon isFavorite={this.isFavorite} />
                  </div>
                </div>

                <div className={styles.manufacturerColumn}>
                  <div className={styles.manufacturerLabel}>Производитель</div>
                  <div className={styles.manufacturerValue}>{ajax_data?.vendor || ' - '}</div>
                  <div className={styles.manufacturerLabel}>Назначение</div>
                  <div className={styles.manufacturerValue}>{ajax_data.options?.appointment || ' - '}</div>
                  {ajax_data?.variants.length > 0 &&
                    <>
                      <div className={styles.manufacturerLabel}>Выбрать размер / цвет</div>
                      <div className={styles.manufacturerValue}>
                        <ButtonGroup style={{ flexWrap: `wrap` }} aria-label="Выбрать размер / цвет">
                          {ajax_data?.variants.map((elm, k) => (
                            <Button key={k} size="sm" href={elm?.link} variant="secondary">{elm?.name}</Button>
                          ))}
                        </ButtonGroup>
                      </div>
                    </>
                  }
                  <div className={styles.imageNote}>*Внешний вид товара может отличаться от фотографии</div>
                </div>

                <div className={styles.volumeColumn}>
                  {this.isInStock ?
                    <div className={styles.stockInfo}>В наличии</div>
                  :
                    <div className={styles.stockInfoErr}>Под заказ</div>
                  }
                </div>

                {ajax_data.options.certificate != '' &&
                  <div className={styles.certificateBadge + ` d-flex d-md-none`}>
                    <span>Доступна продажа по электронному сертификату</span>
                    <svg className={styles.badgeIcon} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.5 5.83366V14.167C17.5 16.667 16.25 18.3337 13.3333 18.3337H6.66667C3.75 18.3337 2.5 16.667 2.5 14.167V5.83366C2.5 3.33366 3.75 1.66699 6.66667 1.66699H13.3333C16.25 1.66699 17.5 3.33366 17.5 5.83366Z" stroke="white" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12.9168 1.66699V8.21698C12.9168 8.58365 12.4835 8.76698 12.2168 8.52531L10.2835 6.74201C10.1252 6.59201 9.87514 6.59201 9.71681 6.74201L7.78352 8.52531C7.51685 8.76698 7.0835 8.58365 7.0835 8.21698V1.66699H12.9168Z" stroke="white" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M11.0415 11.667H14.5832" stroke="white" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M7.5 15H14.5833" stroke="white" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                }
              </div>
            </div>
          </div>

          <div className={styles.card2}>
            <div className={styles.card2Content}>
              {'price' in ajax_data &&
                <>
                  <div className={styles.totalPriceRow}>
                    <div className={styles.totalLabel}>Цена за шт.</div>
                    <div className={styles.totalPrice}>
                      {ajax_data.old_price != `` && <span className='text-decoration-line-through'>{ajax_data.old_price}</span>}
                      {this.priceFormat(ajax_data.price, ' ', 2)} ₽
                    </div>
                  </div>
                  <div className={styles.totalPriceRow}>
                    <div className={styles.totalLabel}>Итого:</div>
                    <div className={styles.totalPrice}>{this.priceFormat(ajax_data.price * quantity, ' ', 2)} ₽</div>
                  </div>
                </>
              }

              <div className={styles.priceNote}>
                <svg className={styles.infoIcon} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.99984 18.3337C14.5832 18.3337 18.3332 14.5837 18.3332 10.0003C18.3332 5.41699 14.5832 1.66699 9.99984 1.66699C5.4165 1.66699 1.6665 5.41699 1.6665 10.0003C1.6665 14.5837 5.4165 18.3337 9.99984 18.3337Z" stroke="#3A3A3A" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M10 6.66699V10.8337" stroke="#3A3A3A" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9.99512 13.333H10.0026" stroke="#3A3A3A" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Цена действительна только при заказе через сайт товаров в наличии</span>
              </div>

              {/* Условный рендеринг: показываем селектор количества и кнопки только если товар в наличии */}
              {this.isInStock ? (
                <>
                  <div className={styles.quantitySelector}>
                    <button onClick={this.decrementQuantity} className={styles.quantityButton}>-</button>
                    <div className={styles.quantityWrapper}>
                      <input
                        onChange={this.handleQuantityChange}
                        onBlur={this.handleQuantityBlur}
                        className={styles.quantityInput}
                        type="text"
                        value={tempQuantity}
                      />
                    </div>
                    <button onClick={this.incrementQuantity} className={styles.quantityButton}>+</button>
                  </div>

                  <div className={styles.actionButtons}>
                    <button onClick={() => this.setFeedback(true)} className={styles.addToCartButton}>
                      Купить в 1 клик
                    </button>
                    <FeedbackForm
                      title={`Оформите заказ в 1 клик`}
                      text={
                        <>
                          Заполните форму и мы свяжемся с вами,<br />чтобы согласовать детали покупки
                        </>
                      }
                      btn={`Отправить`}
                      data={[
                        {
                          name: `Товар`,
                          value: ajax_data?.pagetitle
                        },
                        {
                          name: `Цена`,
                          value: ajax_data?.price
                        },
                        {
                          name: `Количество`,
                          value: quantity
                        }
                      ]}
                      show={show_feedback}
                      handleClose={() => this.setFeedback(false)}
                    />

                    <button onClick={this.add} className={styles.oneClickButton}>
                      <svg className={styles.cartIcon} width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.24092 1.41675L3.67676 3.988" stroke="black" strokeWidth="1.0625" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M10.7598 1.41675L13.3239 3.988" stroke="black" strokeWidth="1.0625" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M1.41699 5.56047C1.41699 4.25005 2.11824 4.1438 2.98949 4.1438H14.0112C14.8824 4.1438 15.5837 4.25005 15.5837 5.56047C15.5837 7.08338 14.8824 6.97713 14.0112 6.97713H2.98949C2.11824 6.97713 1.41699 7.08338 1.41699 5.56047Z" stroke="black" strokeWidth="1.0625"/>
                        <path d="M6.91309 9.91675V12.4313" stroke="black" strokeWidth="1.0625" strokeLinecap="round"/>
                        <path d="M10.1719 9.91675V12.4313" stroke="black" strokeWidth="1.0625" strokeLinecap="round"/>
                        <path d="M2.47949 7.08325L3.47824 13.2033C3.70491 14.5774 4.25033 15.5833 6.27616 15.5833H10.5474C12.7503 15.5833 13.0762 14.6199 13.3312 13.2883L14.5212 7.08325" stroke="black" strokeWidth="1.0625" strokeLinecap="round"/>
                      </svg>
                      {show_cart ? 'В корзине' : 'В корзину'}
                    </button>
                  </div>
                </>
              ) : (
                /* Если товара нет в наличии - показываем сообщение "Под заказ" и кнопку "Оставить заявку" */
                <div className={styles.preorderContainer}>
                  <button 
                    onClick={() => this.setPreorderFeedback(true)} 
                    className={styles.preorderButton}
                  >
                    Оставить заявку
                  </button>

                  {/* Форма для предзаказа */}
                  <FeedbackForm
                    title={`Заявка на предзаказ`}
                    text={
                      <>
                        Товар <strong>{ajax_data?.pagetitle}</strong> временно отсутствует.<br />
                        Оставьте заявку, и мы сообщим о поступлении товара и согласуем детали заказа.
                      </>
                    }
                    btn={`Отправить заявку`}
                    data={[
                      {
                        name: `Товар`,
                        value: ajax_data?.pagetitle
                      },
                      {
                        name: `Артикул`,
                        value: ajax_data?.article || ''
                      },
                      {
                        name: `Цена`,
                        value: ajax_data?.price ? `${this.priceFormat(ajax_data.price, ' ', 2)} ₽` : 'Уточняется'
                      },
                      {
                        name: `Тип заказа`,
                        value: 'Предзаказ (под заказ)'
                      }
                    ]}
                    show={show_preorder_feedback}
                    handleClose={() => this.setPreorderFeedback(false)}
                  />
                </div>
              )}

              <Modal
                centered
                show={this.state.quantityWarning != ''}
                onHide={() => this.setState({ quantityWarning: '' })}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Внимание</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {this.state.quantityWarning}
                </Modal.Body>
                <Modal.Footer>
                  <Button className="text-white" variant="primary" onClick={() => this.setState({ quantityWarning: '' })}>
                    ОК
                  </Button>
                </Modal.Footer>
              </Modal>

              <div className={styles.contactInfo}>
                <span>Возникли вопросы? Свяжитесь с нами в Telegram, WhatsApp или по телефону</span>
                <div className={styles.contactIcons}>
                  {'tglink' in options &&
                    <a href={options.tglink} target="_blank" rel="noopener noreferrer">
                      <Image alt="TG" src={options?.tgicon || ''} width="35" height="35" />
                    </a>
                  }
                  {'walink' in options &&
                    <a href={options.walink} target="_blank" rel="noopener noreferrer">
                      <Image alt="WA" src={options?.waicon || ''} width="35" height="35" />
                    </a>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.cardsRow2}>
          <Accordion 
            activeKey={Array.from(openAccordions)} 
            onSelect={this.handleAccordionToggle}
            className={styles.faqAccordion}
          >
            {ajax_data?.options_table.length > 0 &&
              <Accordion.Item eventKey={`9999`} className={styles.accordionItem}>
                <Accordion.Header className={styles.accordionHeader}>
                  <span className={styles.accordionTitle}>Характеристики:</span>
                </Accordion.Header>
                <Accordion.Body className={styles.specsBody}>
                  <div className={styles.specsGrid}>
                    {ajax_data?.options_table.map((elm, k) => (
                      <React.Fragment key={k}>
                        <div className={styles.specName}>{elm?.name}</div>
                        <div className={styles.specValue}>{elm?.value}</div>
                      </React.Fragment>
                    ))}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            }
            {ajax_data?.accordion.map((item, index) => (
              <Accordion.Item key={index} eventKey={index.toString()} className={styles.accordionItem}>
                <Accordion.Header className={styles.accordionHeader}>
                  <span className={styles.accordionTitle}>{item.name}</span>
                </Accordion.Header>
                <Accordion.Body className={styles.accordionBody}>
                  {this.renderAccordionContent(item.text, index)}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </div>
    )
  }
}

export default ProductCard